export enum arbitrationAgreementStates {
  OPEN = 1,
}
